export default theme => ({
  time: {
    marginLeft: 10,
  },
  container: {
    display: "flex",
  },
  icon: {
    position: "sticky",
    top: "50%",
    marginRight: 5,
  },
});
